import { CheckboxIcon } from '../Icons/CheckboxIcon';
import styles from './Checkbox.module.css';

export const Checkbox = ({ value, onChange, name }) => (
  <label className={styles.checkbox}>
    <input name={name} checked={value} type="checkbox" onChange={onChange} />
    <span
      className={`${styles.checkbox_placeholder} ${
        value ? styles.checkbox_selected : ''
      }`}
      tabIndex={-1}
    >
      {value && <CheckboxIcon />}
    </span>
  </label>
);
